module.exports = __webpack_public_path__ + "static/media/king-luau@2x.1e6d59e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/king-luau@2x.png
// module id = 1358
// module chunks = 1